<script setup lang="ts">
import { useCityStore } from '@/store/city/city'

import SupportDialog from '@/components/Header/Dialogs/SupportDialog.vue'
import HeaderBonuses from '@/components/Header/HeaderBonuses.vue'
import HeaderCitySelect from '@/components/Header/HeaderCitySelect.vue'
import HeaderLogo from '@/components/Header/HeaderLogo.vue'

const { cityInfo } = useCityStore()

const showSupportDialog = ref(false)
</script>

<template>
  <div class="header-mobile-top">
    <header-logo />

    <header-city-select
      v-if="cityInfo.padeg?.imen"
      :city-name="cityInfo.padeg.imen"
    />

    <div class="header-mobile-top__actions">
      <header-bonuses />

      <the-button
        v-if="cityInfo.is_active"
        variant="transparent"
        icon="customer-support"
        icon-color="var(--ui-color-sandy-800)"
        size="xxs"
        radius="lg"
        width="36"
        height="36"
        aria-label="Открыть чат с поддержкой"
        @click="showSupportDialog = !showSupportDialog"
      />
    </div>

    <the-dialog v-model="showSupportDialog">
      <support-dialog />
    </the-dialog>
  </div>
</template>

<style scoped lang="scss">
.header-mobile-top {
  display: flex;
  gap: 0 8px;
  align-items: center;
  width: 100%;
  padding: 16px 20px 0;
  background-color: var(--ui-color-white);

  &__actions {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-left: auto;
  }
}
</style>
